import type { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ProductThumbnail,
  SaleTag,
  Text
} from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

interface ModalProps {
  isOpen: boolean;
  onClose: VoidFunction;
  products: Array<{
    id: string;
    imageUrl: string;
    name: string;
    storeName: string;
  }>;
}

const OutOfStockModal: FC<ModalProps> = ({ isOpen, onClose, products }) => (
  <Modal isOpen={isOpen}>
    <ModalHeader
      onClose={onClose}
      icon={{ name: 'warning-amber', fill: 'warning-500' }}
      title="Productos no disponibles"
    />
    <ModalBody className="co-flex co-flex-col co-p-6 co-gap-4">
      <Text variant="subtitle3">
        Lo sentimos, estos productos se eliminarán del carro porque están
        agotados o no llegan a tu dirección.
      </Text>
      <div>
        {products.map((product, index) => (
          <div
            key={index}
            className={classNames('co-flex co-gap-3 co-p-3 co-pb-7', {
              'co-border-b co-border-b-neutral-300': index < products.length - 1
            })}
          >
            <ProductThumbnail
              variant="image-counter"
              key={product.id}
              src={product.imageUrl}
            />
            <div className="co-flex co-flex-col co-gap-1">
              <Text variant="body2" weight={700}>
                {product.name}
              </Text>
              <div>
                <SaleTag label="Vendido por" storeName={product.storeName} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </ModalBody>
    <ModalFooter primaryButton={{ label: 'Entendido', onClick: onClose }} />
  </Modal>
);

export default OutOfStockModal;
